<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <!-- Popup Nav Header -->
    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon>Back
    </div>
    <div class="header text-left">Edit Homepage Section</div>

    <!-- Title -->
    <v-row>
      <v-col cols="12">
        <label for="ann-title">Section Name</label>
        <input
          id="ann-title"
          type="text"
          v-model="name"
          @input="$v.name.$touch()"
        />
        <div class="error-msg" v-show="$v.name.$invalid && $v.name.$dirty">
          This is a required field.
        </div>
        <br />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3">
        <label for="ann-title">Enable</label>
        <v-switch v-model="isEnabled"></v-switch>
        <br />
      </v-col>
    </v-row>

    <!-- Form Submit Button -->
    <v-row>
      <v-col cols="4" md="3">
        <v-btn color="#00457C" @click="updateForm">Submit</v-btn>
      </v-col>
    </v-row>

    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success">Homepage section updated successfully.</v-alert>
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import { required } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    LoadingScreen,
  },

  data() {
    return {
      name: "",
      loading: false,
      success: false,
      error: false,
      isEnabled: true,
      selectedId: this.$route.params.itemId,
    };
  },

  validations: {
    name: {
      required,
    },
  },

  mounted() {
    Axios.get(
      process.env.VUE_APP_HOST_SERVER +
        "/api/homepage_layout/edit/" +
        this.selectedId
    )
      .then((res) => {
        this.name = res.data.name;
        this.isEnabled = res.data.isEnabled;
      })
      .catch((err) => console.log(err));
  },

  methods: {
    goBack() {
      this.$router.push({ name: "HomepageSections" }).catch(() => {});
    },
    // TODO: validate redirect url to have http://
    // TODO: validate image to be of a certain aspect ratio
    setImage(file) {
      if (file !== null) {
        // Set image file
        this.imageFile = file;
        this.imageFileName = file.name;
      }
    },
    updateForm() {
      this.loading = true; //enable loading screen once user clicks submit

      var updatedDetails = {
        name: this.name,
        isEnabled: this.isEnabled,
      };

      // Update Mongodb
      Axios.put(
        process.env.VUE_APP_HOST_SERVER +
          "/api/homepage_layout/update/" +
          this.selectedId,
        updatedDetails
      )
        .then((res) => {
          console.log(res);
          this.loading = false; //disable loading screen once request is handled
          this.success = true; //show success message
          this.error = false;
          console.log("Successfully updated the layout ", updatedDetails);
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        });
    },
    clickImageInput() {
      this.$refs.imageFileInput.click();
    },
  },
};
</script>

<style scoped>
.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  margin-bottom: 40px;
  font-size: 16px;
  cursor: pointer;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.content .date-labels,
.content .photo-label {
  padding-bottom: 0;
}

.content .date-labels > div,
.content .photo-label > div {
  padding-bottom: 0;
}

.content .date-pickers > div,
.content .photo-picker > div {
  padding-top: 0;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"],
input[type="number"],
input[type="date"],
textarea,
select {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}
</style>
